module.exports = __webpack_public_path__ + "static/media/health-news-bg.faf20eb6.png";